import { gql } from "@apollo/client";

const CLASSIFY_AISLE = gql`
  query classifyAisle($ingredient: String!) {
    classifyAisle(ingredient: $ingredient)
  }
`;

export default CLASSIFY_AISLE;
